export const mapSwarmToSwarmInActionRes = (swarm, eventModel, swarmHasPendingBuyRequest) => {
  if (!swarm || !eventModel) {
    throw new Error('Invalid data received for swarm mapping.');
  }
  return {
    id: swarm.id,
    bteId: swarm.bteId,
    running: swarm.running,
    salesDate: swarm.salesDate || null,
    isNow: swarm.isNow,
    hasPendingBuyRequest: swarmHasPendingBuyRequest,
    isMonitor: swarm.isMonitor,
    buyManagerId: swarm.buyManagerId,
    code: swarm.code,
    reward: swarm.reward,
    alternativeEventUrl: swarm.alternativeEventUrl,
    event: eventModel
      ? {
          bteId: eventModel.bteId,
          name: eventModel.name,
          date: eventModel.date || null,
          performers: eventModel.performers || [],
          venue: eventModel.venue || {},
          primaryEventUrl: eventModel.primaryEventUrl,
          entityLink: eventModel.entityLink
        }
      : null,
    completed: swarm.completed,
    accepted: swarm.accepted,
    pending: swarm.pending,
    isMonitor: swarm.isMonitor,
    isTraining: swarm.isTraining,
    buyManagerId: swarm.buyManagerId,
    code: swarm.code,
    reward: swarm.reward,
    isApproveAllActive: swarm.isApproveAllActive,
    isAutoBuyActive: swarm.isAutoBuyActive,
    isClosed: swarm.isClosed
  };
};
